import { useMutation } from '@tanstack/react-query'
import { eventsService } from '@cobu/api-client'

export function useCreateGroupEventMutation() {
  return useMutation({
    mutationFn: ({ groupId, eventData, creator }: { groupId: string; eventData: any; creator: string }) =>
      eventsService.createGroupEvent(groupId, eventData, creator),
  })
}

export function useUpdateGroupEventMutation() {
  return useMutation({
    mutationFn: ({ eventId, groupId, eventData }: { eventId: string; groupId: string; eventData: any }) =>
      eventsService.updateGroupEvent(eventId, groupId, eventData),
  })
}


